/**
 * Centralized localStorage key names used throughout the application.
 *
 * Keeps all storage keys in one place to avoid typos and simplify renaming.
 */
export const STORAGE_KEYS = {
	OFFLINE_VIEWS: 'pilar_offline_views',
	VIDEO_PROGRESS: 'pilar_video_progress',
	LAST_VIDEO_STATE: 'pilar_last_video_state'
} as const;

export type StorageKey = (typeof STORAGE_KEYS)[keyof typeof STORAGE_KEYS];
